import { createSelector } from 'reselect';

export default ({
  getEmail: createSelector(
    state => state.login.register.resendEmail,
    state => state
  )
});